export default "__VITE_ASSET__CvQg9LT2__"